import { AbstractControl, ValidationErrors } from '@angular/forms';

export function validateNoCreditCard(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  const candidates = extractDigitSequences(value);
  for (const candidate of candidates) {
    if (isCreditCardNumber(candidate)) {
      return { containsCreditCard: true };
    }
  }

  return null;
}

function extractDigitSequences(text: string): string[] {
  const pattern = /(?:\d[\s\-\.]*){13,19}/g;
  const matches: string[] = text.match(pattern) || [];
  const candidates = new Set<string>();

  matches.forEach(match => {
    const digits = match.replace(/[\s\-\.]/g, '');

    for (let start = 0; start < digits.length; start++) {
      for (let length = 13; length <= 19 && start + length <= digits.length; length++) {
        candidates.add(digits.substring(start, start + length));
      }
    }
  });

  return Array.from(candidates);
}

function isCreditCardNumber(digits: string): boolean {
  if (!matchesCardBinPattern(digits)) return false;
  return passesLuhnCheck(digits);
}

function matchesCardBinPattern(digits: string): boolean {
  return (
    /^4\d{12,15}$/.test(digits) ||
    /^5[1-5]\d{14}$/.test(digits) ||
    /^3[47]\d{13}$/.test(digits) ||
    /^6(?:011|5\d{2}|4[4-9]\d)\d{12}$/.test(digits) ||
    /^35(?:2[89]|[3-8]\d)\d{12}$/.test(digits) ||
    /^3(?:0[0-5]|[68]\d)\d{11,13}$/.test(digits)
  );
}

// Luhn algorithm: https://en.wikipedia.org/wiki/Luhn_algorithm
function passesLuhnCheck(digits: string): boolean {
  let sum = 0;
  let alternate = false;
  for (let i = digits.length - 1; i >= 0; i--) {
    let n = parseInt(digits[i], 10);
    if (alternate) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    alternate = !alternate;
  }
  return sum % 10 === 0;
}
